import './load-mask.js';
import { initEnergyEfficiency } from './widgets/energy-efficiency.js';

// product_list_history_manager_script.tpl re-invokes this global after every AJAX list reload.
window.initEnergyEfficiency = initEnergyEfficiency;
initEnergyEfficiency();

document.addEventListener('DOMContentLoaded', function () {
  // Pagination is a full-page reload, so page 2+ can render with the list below the fold.
  const page = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
  if (page > 1) {
    document.getElementById('list-with-filter-wrapper')?.scrollIntoView({ block: 'start' });
  }
});
